import { render, staticRenderFns } from "./error-network.vue?vue&type=template&id=8d2db0c4&"
import script from "./error-network.vue?vue&type=script&lang=js&"
export * from "./error-network.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports